import { amber, pink, teal, yellow } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  typography: {
    fontSize: 13,
    color: '#000',
    useNextVariants: true,
    fontFamily: [
      'system-ui',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    textTransform: 'none',
    button: {
      fontSize: 15,
    },
  },
  // värit teemalle
  palette: {
    primary: {
      main: '#ffd740',
      light: amber[900],
      contrastText: '#000',
    },
    secondary: {
      main: teal[500],
      light: teal[200],
      dark: teal[700],
      contrastText: '#000',
    },
    error: {
      main: pink[500],
      light: pink[200],
      dark: pink[700],
      contrastText: '#000',
    },
    oma: {
      main: '#000',
    },
    contrast: {
      main: yellow[100],
      dark: yellow[700],
    },
  },
})